import * as React from 'react';
import { useSensitivityTooltip_unstable } from './useSensitivityTooltip';
import { renderSensitivityTooltip_unstable } from './renderSensitivityTooltip';
import { useSensitivityTooltipStyles_unstable } from './useSensitivityTooltipStyles';
// SensitivityTooltip component - TODO: add more docs
export const SensitivityTooltip = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useSensitivityTooltip_unstable(props, ref);
  useSensitivityTooltipStyles_unstable(state);
  return renderSensitivityTooltip_unstable(state);
});
SensitivityTooltip.displayName = 'SensitivityTooltip';
//# sourceMappingURL=SensitivityTooltip.js.map